import { Component } from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MUIButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  root: {
    minWidth: 80,
  },
  buttonContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  isLoading: {
    cursor: 'not-allowed !important',
    '&:active': {
      pointerEvents: 'none',
    },
  },
  text: {
    padding: '14px 24px',
  },
  primaryBlue: {
    ...theme.button.primaryBlue.default,
    '&:hover': {
      ...theme.button.primaryBlue.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
  primaryBlueHighLight: {
    ...theme.button.primaryBlueHighLight.default,
    '&:hover': {
      ...theme.button.primaryBlueHighLight.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
  primaryBlueSpinner: {
    ...theme.button.primaryBlue.spinner.default,
    '&.hover': {
      ...theme.button.primaryBlue.spinner.hover,
    },
  },
  primaryHighlight: {
    ...theme.button.primaryHighlight.default,
    '&:hover': {
      ...theme.button.primaryHighlight.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
  primaryHighlightSpinner: {
    ...theme.button.primaryHighlight.spinner.default,
    '&.hover': {
      ...theme.button.primaryHighlight.spinner.hover,
    },
  },
  primaryGreen: {
    ...theme.button.primaryGreen.default,
    '&:hover': {
      ...theme.button.primaryGreen.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
  primaryGreenSpinner: {
    ...theme.button.primaryGreen.spinner,
  },
  primaryGrey: {
    ...theme.button.primaryGrey.default,
    '&:hover': {
      ...theme.button.primaryGrey.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
  IconPrimaryGrey: {
    ...theme.button.IconPrimaryGrey.default,
    '&:hover': {
      ...theme.button.IconPrimaryGrey.hover,
    },
    '&.disabled': {
      ...theme.button.disabled,
      '&:hover': {
        ...theme.button.disabled,
      },
    },
  },
});

class Button extends Component {
  constructor() {
    super();
    this.state = {
      isHover: false,
    };
  }

  render() {
    const {
      classes,
      className,
      style,
      type,
      topic,
      isDisable,
      children,
      width,
      height,
      isLoading,
      onClick,
      ...others
    } = this.props;
    const { isHover } = this.state;
    return (
      <MUIButton
        type={type}
        disabled={isDisable}
        style={{ width, height, ...style }}
        className={classNames([
          classes[topic],
          ...(isDisable ? ['disabled'] : []),
          isLoading && classes.isLoading,
          className,
        ])}
        classes={{
          root: classes.root,
          text: classes.text,
        }}
        onFocus={() => {}}
        onClick={onClick}
        onMouseOver={() => {
          this.setState({ isHover: true });
        }}
        onMouseLeave={() => {
          this.setState({ isHover: false });
        }}
        {...others}
      >
        {isLoading ? (
          <CircularProgress
            className={classNames([
              classes[`${topic}Spinner`],
              ...(isHover ? ['hover'] : []),
            ])}
          />
        ) : (
          <div className={classes.buttonContent}>{children}</div>
        )}
      </MUIButton>
    );
  }
}

Button.defaultProps = {
  topic: 'primary',
  isDisable: false,
};

export default withStyles(styles, { withTheme: true })(Button);
